<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <v-icon class="float-right mr-2 mt-2">mdi-dots-horizontal</v-icon>
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.packOrderID')}}
                  <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.packOrderIDState')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{
                    getdrug.packOrderId
                      ? getdrug.packOrderId
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <v-icon class="float-right mr-2 mt-2">mdi-dots-horizontal</v-icon>
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.packQuantityOrdered')}}
                  <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.packQuantityOrderedState')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{
                    getdrug.packQtyOrdered
                      ? getdrug.packQtyOrdered
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <v-icon class="float-right mr-2 mt-2">mdi-dots-horizontal</v-icon>
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.packPrice')}}<v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.packPriceStatement')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{
                    getdrug.packPrice
                      ? getdrug.packPrice
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
     
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <v-icon class="float-right mr-2 mt-2">mdi-dots-horizontal</v-icon>
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.packPricecurrency')}}
                  <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.packPricecurrencyState')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{
                    getdrug.packPriceCurrency
                      ? getdrug.packPriceCurrency
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <v-icon class="float-right mr-2 mt-2">mdi-dots-horizontal</v-icon>
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.packPaydate')}}<v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.packPaydateState')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                     {{
                    payDate
                      ? payDate
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <v-icon class="float-right mr-2 mt-2">mdi-dots-horizontal</v-icon>
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  > {{$t('drug.packShippingID')}}
                  <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.packShippingIdState')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{ getdrug.packShippingId ? getdrug.packShippingId : "Not Specified" }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
       <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <v-icon class="float-right mr-2 mt-2">mdi-dots-horizontal</v-icon>
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.packShippingDate')}}<v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.packShippingDateState')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{ shipDate ? shipDate : "Not Specified" }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="green2 elevation-0">
          <v-icon class="float-right mr-2 mt-2">mdi-dots-horizontal</v-icon>
          <v-list three-line class="green2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('drug.packOrderStatus')}}<v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                       v-bind="attrs"
                                       v-on="on"
                                    >
                                    mdi-information-outline
                                    </v-icon>
                                 </template>
                                 <span>{{$t('drug.packOrderStatusState')}}</span>
                              </v-tooltip></v-list-item-subtitle
                >
                <v-list-item-title class="text-h6 mt-2 text-capitalize">
                  {{
                    getdrug.packOrderStatus
                      ? getdrug.packOrderStatus
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "PackOrder",
     mounted(){
    this.shipDate=this.dateFormat(this.getdrug.packShippingDate)
    this.payDate=this.dateFormat(this.getdrug.packPayDate)
  },
  computed: {
    ...mapGetters(["getdrug"]),
  },
      data(){
    return{
      shipDate:"",
      payDate:"",
    }
  },
  props:["dateFormat"]
};
</script>